import { createFileRoute, redirect } from '@tanstack/react-router'
import { AccessScreen } from '@/features/inventory-access/access-screen'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/inventory/access')({
  beforeLoad: ({ context }) => {
    // The API's own gate (WarehouseAccessGrantController::assertAdministrator).
    if (!hasGrant(context.queryClient, 'warehouse.access_all')) throw redirect({ to: '/' })
  },
  component: AccessScreen,
})
